module.exports = __webpack_public_path__ + "img/spw.ed5b236a.png";